module.exports = __webpack_public_path__ + "static/media/pp.ee786962.svg";